import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Box } from "@mui/material";
import { ISortableFunctionalLocationCard } from "./interfaces";

export function SortableFunctionalLocationCard({ id, children }: ISortableFunctionalLocationCard) {
    const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
    };

    return (
        <Box ref={setNodeRef} style={style} {...attributes} {...listeners}>
            {children}
        </Box>
    );
}
